module.exports = __webpack_public_path__ + "static/media/think.48108abd.png";